import { ContentContainer, useDebouncedSearch } from '@gorila-shared-ui/components';
import { useState } from 'react';
import { WebServiceLogList } from '../../logs/WebServiceLogList';
import { WebServiceLogsFiltersBar } from '../../logs/WebServiceLogsFiltersBar';

export function WebServiceLogsPage() {
  const { search, setSearch, trigger: debouncedSearch } = useDebouncedSearch('');
  const [reloadPage, setReloadPage] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState<string>();
  const [selectedSubClientId, setSelectedSubClientId] = useState<string>();

  return (
    <ContentContainer>
      <WebServiceLogsFiltersBar
        search={search}
        onChangeSearch={setSearch}
        onReloadPage={() => setReloadPage(!reloadPage)}
        selectedClientId={selectedClientId}
        selectedSubClientId={selectedSubClientId}
        setSelectedClientId={setSelectedClientId}
        setSelectedSubClientId={setSelectedSubClientId}
      />
      <WebServiceLogList
        search={debouncedSearch}
        reloadPage={reloadPage}
        selectedClientId={selectedClientId}
        selectedSubClientId={selectedSubClientId}
      />
    </ContentContainer>
  );
}
